import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { LOCAL_STORAGE } from "shared/constants";
import id from "./shared/languages/id.json";
import en from "./shared/languages/en.json";

// Same setup as spott-client's and spott-instructor's src/i18n: the
// persisted choice wins, the app defaults to Indonesian, and switching is a
// synchronous changeLanguage (both dictionaries are statically bundled).

export type Lang = "en" | "id";

/** Persisted choice wins; otherwise the app defaults to Indonesian. */
const detectInitialLang = (): Lang => {
  try {
    const stored = localStorage.getItem(LOCAL_STORAGE.LANGUAGE);
    if (stored === "en" || stored === "id") return stored;
  } catch {
    /* localStorage unavailable */
  }
  return "id";
};

i18n.use(initReactI18next).init({
  lng: detectInitialLang(),
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
  resources: {
    id: {
      translation: id,
    },
    en: {
      translation: en,
    },
  },
});

/** Switch language and persist the choice. */
export const setLang = (next: Lang): void => {
  void i18n.changeLanguage(next);
  try {
    localStorage.setItem(LOCAL_STORAGE.LANGUAGE, next);
  } catch {
    /* storage unavailable */
  }
};

/** The currently-active language, narrowed to the two we support. */
export const currentLang = (): Lang => (i18n.language === "en" ? "en" : "id");

export default i18n;
